var mixContainerCheck = $('[data-blog-mix-grid]').length;
if (mixContainerCheck > 0) {
  var mixer = mixitup('[data-blog-mix-grid]', {
      controls: {
        toggleLogic: 'or'
      },
      pagination: {
        limit: 9
      }
  });
}

$('[data-blog-filter-btn]').on('click',function() {
  $('[data-blog-filter-btn].active').removeClass('active');
  $(this).addClass('active');
});